module.exports = __webpack_public_path__ + "media/images/iconUp__accent-ecdd25a416c299cf081dd8d7fed6c8a1.png";